var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-brand"},[_c('a',{staticClass:"navbar-item",attrs:{"href":"/"}},[_c('span',{staticClass:"icon-text"},[_vm._m(0),_c('b',[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-shield-alt"})])
}]

export { render, staticRenderFns }